import React, { useEffect, useRef } from 'react'
import { useAppDispatch } from '../../hooks'
import { authActions } from './actions'

/**
 * Componente para inicializar verificação de autenticação ao carregar a aplicação
 * Deve ser usado uma vez no App.tsx
 */
export const AuthInitializer: React.FC = () => {
  const dispatch = useAppDispatch()
  const hasCheckedAuth = useRef(false)

  useEffect(() => {
    // Evitar execuções duplicadas (especialmente no React Strict Mode)
    if (hasCheckedAuth.current) {
      return
    }

    hasCheckedAuth.current = true
    dispatch(authActions.checkAuthRequest())
  }, [dispatch])

  return null
}

